import { ListsSearch } from "@/components/lists/ListsSearch";
import { useListsFilter } from "@/contexts/ListsFilterContext";

export const ListsFilterWrapper = () => {
  const {
    searchTerm,
    setSearchTerm,
    showFavoritesOnly,
    setShowFavoritesOnly,
    currentPage,
    setCurrentPage
  } = useListsFilter();

  // Reset to first page when filters change
  const handleSearchTermChange = (term: string) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };

  const handleShowFavoritesOnlyChange = (show: boolean) => {
    setShowFavoritesOnly(show);
    setCurrentPage(1);
  };

  return (
    <ListsSearch 
      searchTerm={searchTerm}
      setSearchTerm={handleSearchTermChange}
      showFavoritesOnly={showFavoritesOnly}
      setShowFavoritesOnly={handleShowFavoritesOnlyChange}
    />
  );
};
